import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import moment from 'moment'
import uuidV4 from 'uuid/v4'
import RenderTaskForm from './RenderCreateTaskForm/RenderCreateTaskForm'
import { dateFormat } from '../../../../componentIsoMophic/ScrumBoard/FieldFormats'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import { CreateTaskWrapper } from './TaskCreateOrUpdate.style'
import OrgAction from '../../../../redux/organization/actions'

import * as Yup from 'yup'

const initialValues = {
    id: '',
    title: '',
    description: '',
    labels: [],
    assignees: [],
    attachments: [],
    comments: [],
    todos: [],
    column_id: '',
    editing: false,
    created_at: moment(Date.now()),
    updated_at: moment(Date.now()),
    due_date: moment(Date.now()),
    selectOptions: ['success', 'error', 'processing', 'warning', 'default'],
    selectAssignees: ['Mark', 'Bob', 'Anthony'],
}
const TaskForm = props => {
    useEffect(() => {
        return () => {
            console.log('reset data update task')
            props.deleteListTagUpdate()
            props.deleteListOrgQuery()
            if (props.initials) {
                props.getDetailTaskById(props.initials.IdOfTask)
                props.getListRanking(props.initials.IdOfTask)
            }
        }
    }, [props.deleteListOrgQuery])
    console.log('props.initials', props.initials)
    const initials = {
        ...initialValues,
        ...props.initials,
        due_date: moment(
            props.initials && props.initials.due_date
                ? props.initials.due_date * 1000
                : Date.now()
        ),
        updated_at: moment(Date.now()),
    }
    const SignupSchema = Yup.object().shape({
        title: Yup.string()
            .min(0, 'Không được để trống')
            .required('Không được để trống'),
        description: Yup.string()
            .min(0, 'Không được để trống')
            .required('Không được để trống'),
    })

    const handleSubmit = formProps => {
        console.log('formProps', formProps)

        const listMedia = []
        props.ListCurrentMedia.map(media => {
            listMedia.push(media.media_id)
        })

        if (formProps.type === 'require') {
            const listOrgUpdateId = []
            props.listOrgUpdate.map(data => {
                listOrgUpdateId.push(data.oid)
            })
            const listObject = []
            props.ListCurrentObject.map(data => {
                listObject.push(data.object_id)
            })
            const listEventId = []
            props.ListCurrentEvent.map(event => {
                listEventId.push(event.event_id)
            })
            const listuidReceuive =[]
            props.currentUserPickUp.map(user => {
                listuidReceuive.push(user.uid)
            })
            const dataUpdate = {
                avatar: formProps.avatar,
                deadline: moment(formProps.due_date).format('X') >> 0,
                lst_event_id: listEventId,
                lst_hashtag: formProps.lst_hashtag.concat(
                    props.listUpdateHashTag
                ),
                lst_object_id: listObject,
                lst_organ_receive_id: formProps.lst_organ_receive_id.concat(
                    listOrgUpdateId
                ),
                lst_uid_receive: formProps.lst_uid_receive.concat(listuidReceuive),
                lst_media: listMedia,
                name: formProps.title,
                note: formProps.description,
                process: formProps.process,
            }
            props.updateTask(dataUpdate, formProps.IdOfTask)
            console.log('formProps', dataUpdate)
        }

        props.closeDrawer()
    }

    return (
        <CreateTaskWrapper>
            <Formik
                initialValues={initials}
                onSubmit={handleSubmit}
                validationSchema={SignupSchema}
                render={formikProps => (
                    <RenderTaskForm
                        {...formikProps}
                        onCancel={() => props.closeDrawer}
                        onDelete={() => {
                            // props.deleteTask({
                            //     taskId: props.initials.id,
                            //     column_id: props.columnId,
                            // })
                            props.closeDrawer()
                        }}
                        onEditCancel={() => {
                            // props.cancelEditTask(props.initials)
                            props.openDrawer({
                                drawerType: 'CARD_DETAILS',
                                drawerProps: {
                                    task: {
                                        id: 'requireID',
                                        column_id: 'column1',
                                        title: props.currentBoard.name,
                                        description: props.currentBoard.note,
                                        labels: props.currentBoard.lst_hashtag,
                                        due_date: props.currentBoard.deadline,
                                        lst_event_id:
                                            props.currentBoard.lst_event_id,
                                        lst_hashtag:
                                            props.currentBoard.lst_hashtag,
                                        lst_object_id:
                                            props.currentBoard.lst_object_id,
                                        lst_organ_receive_id:
                                            props.currentBoard
                                                .lst_organ_receive_id,
                                        lst_uid_receive:
                                            props.currentBoard.lst_uid_receive,
                                        lst_media: props.currentBoard.lst_media,
                                        assignees: [],
                                        attachments: [],
                                        comments: [],
                                        todos: [],
                                        editing: false,
                                        created_at:
                                            props.currentBoard.create_time,
                                        updated_at: '',
                                        type: 'require',
                                        avatar: props.currentBoard.avatar,
                                        IdOfTask: props.currentBoard.task_id,
                                        process: props.currentBoard.process,
                                        status: props.currentBoard.status,
                                    },
                                    columnId: props.columnId,
                                },
                            })
                        }}
                    />
                )}
            />
        </CreateTaskWrapper>
    )
}
export default connect(
    (state, ownProps) => {
        console.log('state.qbmedia', state.qbmedia.currentListMedia)
        return {
            listOrgUpdate: state.organization.listOrgUpdate,
            listUpdateHashTag: state.scrumBoard.listUpdateHashTag,
            ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
            ListCurrentObject: state.scrumBoard.ListCurrentObject,
            ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
            currentBoard: state.scrumBoard.currentBoard,
            currentUserPickUp: state.scrumBoard.currentUserPickUp

        }
    },
    {
        ...scrumBoardActions,
        ...OrgAction.action,
    }
)(TaskForm)
